import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { SearchResult } from '../api/libraryApi';
import { searchTerms } from './Highlighted';
import { ReportCard } from './ReportCard';

type Props = { items: SearchResult[]; isLoading: boolean; query: string };

/** Reports two to a row on wider screens, one on phones; card-shaped placeholders while loading. */
export function ReportGrid({ items, isLoading, query }: Props) {
  if (isLoading) {
    return (
      <Box sx={gridSx} aria-busy="true" aria-label="Loading reports">
        {Array.from({ length: 6 }, (_, i) => <Skeleton key={`card-${i}`} variant="rounded" height={170} sx={{ borderRadius: 1.5 }} />)}
      </Box>
    );
  }
  const terms = searchTerms(query);
  return (
    <Box component="section" aria-label="Reports" sx={gridSx}>
      {items.map((doc, i) => <ReportCard key={doc.id} doc={doc} terms={terms} index={i} />)}
    </Box>
  );
}

// minmax(0, 1fr): long analyst names truncate inside the card instead of widening the column.
const gridSx = { display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' }, gap: 1.5 } as const;
